module.exports = __webpack_public_path__ + "static/media/galerija_2013 (9).b3638238.JPG";